
const list = {
  path: 'list/:pages',
  component: resolve => require(['../../../../../pages/modules/openPlatform/list'], resolve),
}

export default list
